export enum ExportPdfType {
  List = 'list',
  Cards = 'cards',
}
